import { EmptyViewType } from '@components'

import { ScoutConnectionStatus } from '../enums/scoutConnectionStatus'
import { ScoutEmptyStateMode } from '../enums/scoutEmptyStateMode'

export const scoutEmptyStateViewVariants: Record<ScoutEmptyStateMode, Record<ScoutConnectionStatus, EmptyViewType>> = {
  filePicker: {
    connected: 'scoutConnectedFilePicker',
    notConnected: 'scoutNotConnected',
    processing: 'scoutConnectedProcessing',
  },
  uploadPage: {
    connected: 'scoutConnected',
    notConnected: 'scoutNotConnected',
    processing: 'scoutConnectedProcessing',
  },
}
